import React, { useState, useCallback, useEffect } from 'react';
import useApi from '../../api/useApi';
import Notification from '../../components/Notification';

function index() {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(sessionStorage.user).organization.id;
  let formModel = null;
  const [orgData, setOrgData] = useApi();
  const [org, setOrg] = useState([]);
  const [formData, setFormData] = useState(formModel);
  const [{ isLoading, isError, data }, updateData] = useApi();
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [popup, setPopup] = useState(false);
  const [edit, setEdit] = useState(false);
  const showNotification = (typ, msg) => {
    setType(typ);
    setMessage(msg);
    setNotification(true);
  };

  const alertMsg = (msg) => {
    setNotification(msg);
  };

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const handleAddressChange = useCallback((e) =>
    setFormData({ ...formData, address: { ...formData.address, [e.target.name]: e.target.value } })
  );

  useEffect(() => {
    user && setOrgData(`/organization/${orgId}`, 'GET');
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setType('success');
      setMessage('Organization updated successfully');
      setNotification(true);
    }
    if (isError) {
      setType('error');
      setMessage(data);
      setNotification(true);
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (!orgData.isLoading && !orgData.isError && orgData.data) {
      setOrg(orgData.data);
      formModel = {
        website: orgData?.data?.organization?.website,
        email: orgData?.data?.organization?.email,
        contactNo: orgData?.data?.organization?.contactNo,
        address: {
          location: orgData?.data?.organization?.Address?.locality,
          city: orgData?.data?.organization?.Address?.city,
          country: orgData?.data?.organization?.Address?.country,
          state: orgData?.data?.organization?.Address?.state,
          zip: orgData?.data?.organization?.Address?.zip,
        },
      };
      setFormData(formModel);
    }
    if (orgData.isError) {
      showNotification('error', orgData.data);
    }
  }, [orgData.isLoading, orgData.isError, orgData.data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    updateData(`/organization/${orgId}`, 'PATCH', formData);
    setTimeout(() => {
      setPopup(true);
    }, 1000);
  };

  useEffect(() => {
    if (!isLoading && !isError && popup) {
      showNotification('success', 'Organization updated successfully');
      setPopup(false);
      setEdit(false);
    }
    if (isError) {
      showNotification('error', data);
      setPopup(false);
    }
  }, [isLoading, isError, popup]);

  return (
    <>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      <div className="h-auto w-3/5 m-auto organisation_resp hideScroll justify-center items-center bg-white left-1/3 rounded-b-md overflow-auto">
        <div className="w-full">
          <div className="block px-4 py-2.5 bg-primary text-white relative">
            <span className="text-base font-medium">Organization Information</span>
            {!edit && (
              <img
                src="assets/img/Edit_White.svg"
                className="h-4 absolute right-4 top-4"
                alt=""
                onClick={() => {
                  setEdit(true);
                }}
              />
            )}
          </div>
        </div>
        <div className="m-12 mt-6 mb-6 text-xs org_inline">
          {!edit && (
            <p className="mt-5 w-full text-base font-semibold text-textBlue1">
              {orgData?.data?.organization?.organizationName}
            </p>
          )}
          {!edit && formData && (
            <div>
              <div className="flex w-full mt-6">
                <div className="w-1/3">
                  <span className="text-gray-400 text-xs font-medium">Customer API Key</span>
                  <p className="mt-2 text-gray-600 text-sm font-medium">
                    {orgData?.data?.organization?.ClientApiKey?.clientId}
                  </p>
                </div>
                <div className="w-1/3">
                  <span className="text-gray-400 text-xs font-medium">Website</span>
                  <p className="mt-2 text-gray-600 text-sm font-medium">{formData.website}</p>
                </div>
                <div className="w-1/3">
                  <span className="text-gray-400 text-xs font-medium">Email</span>
                  <p className="mt-2 text-gray-600 text-sm font-medium">{formData.email}</p>
                </div>
              </div>
              <div className="flex w-full mt-6">
                <div className="w-1/3">
                  <span className="text-gray-400 text-xs font-medium">Phone Number</span>
                  <p className="mt-2 text-gray-600 text-sm font-medium">{formData.contactNo}</p>
                </div>
                <div className="w-1/3">
                  <span className="text-gray-400 text-xs font-medium">Locality</span>
                  <p className="mt-2 text-gray-600 text-sm font-medium">{formData.address.location}</p>
                </div>
                <div className="w-1/3">
                  <span className="text-gray-400 text-xs font-medium">City</span>
                  <p className="mt-2 text-gray-600 text-sm font-medium">{formData.address.city}</p>
                </div>
              </div>
              <div className="flex w-full mt-6">
                <div className="w-1/3">
                  <span className="text-gray-400 text-xs font-medium">State</span>
                  <p className="mt-2 text-gray-600 text-sm font-medium">{formData.address.state}</p>
                </div>
                <div className="w-1/3">
                  <span className="text-gray-400 text-xs font-medium">Country</span>
                  <p className="mt-2 text-gray-600 text-sm font-medium">{formData.address.country}</p>
                </div>
                <div className="w-1/3">
                  <span className="text-gray-400 text-xs font-medium">Zip</span>
                  <p className="mt-2 text-gray-600 text-sm font-medium">{formData.address.zip}</p>
                </div>
              </div>
            </div>
          )}
          {edit && formData && (
            <div>
              <form className="mt-2 flex flex-wrap" onSubmit={handleSubmit} autoComplete="off">
                <div className="flex w-full mt-6">
                  <div className="w-5/12">
                    <span className="text-gray-400">Customer API Key</span>
                    <input
                      type="text"
                      value={orgData?.data?.organization?.ClientApiKey?.clientId}
                      name="api-key"
                      disabled
                      placeholder="Customer API Key"
                      autoComplete="off"
                      className="inputLabelText px-4 py-3 mt-2 rounded-xl focus:outline-none text-gray-400"
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="w-5/12 ml-20">
                    <span className="text-gray-400 ml-2">Website</span>
                    <input
                      type="text"
                      value={formData.website}
                      name="website"
                      placeholder="Website"
                      autoComplete="off"
                      className="inputLabelText ml-2 mt-2 px-4 py-3 focus:outline-none"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="flex w-full mt-6">
                  <div className="w-5/12">
                    <span className="text-gray-400">Email</span>
                    <input
                      type="email"
                      value={formData.email}
                      name="email"
                      placeholder="Email"
                      autoComplete="off"
                      className="inputLabelText px-4 py-3 mt-2 rounded-xl focus:outline-none"
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="w-5/12 ml-20">
                    <span className="text-gray-400 ml-2">Phone Number</span>
                    <input
                      type="tel"
                      value={formData.contactNo}
                      name="contactNo"
                      placeholder="Phone Number"
                      autoComplete="off"
                      className="inputLabelText ml-2 mt-2 px-4 py-3 focus:outline-none"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="flex w-full mt-6">
                  <div className="w-5/12">
                    <span className="text-gray-400">Locality</span>
                    <input
                      type="text"
                      value={formData.address.location}
                      name="location"
                      placeholder="Locality"
                      autoComplete="off"
                      className="inputLabelText px-4 py-3 mt-2 rounded-xl focus:outline-none"
                      onChange={handleAddressChange}
                    />
                  </div>
                  <div className="w-5/12 ml-20">
                    <span className="text-gray-400 ml-2">City</span>
                    <input
                      type="text"
                      value={formData.address.city}
                      name="city"
                      onChange={handleAddressChange}
                      placeholder="City"
                      autoComplete="off"
                      className="inputLabelText ml-2 mt-2 px-4 py-3 focus:outline-none"
                      // onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="flex w-full mt-6">
                  <div className="w-5/12">
                    <span className="text-gray-400">State</span>
                    <input
                      type="text"
                      value={formData.address.state}
                      name="state"
                      placeholder="State"
                      autoComplete="off"
                      className="inputLabelText px-4 py-3 mt-2 rounded-xl focus:outline-none"
                      onChange={handleAddressChange}
                    />
                  </div>
                  <div className="w-5/12 ml-20">
                    <span className="text-gray-400 ml-2">Country</span>
                    <input
                      type="text"
                      value={formData.address.country}
                      name="country"
                      onChange={handleAddressChange}
                      placeholder="Country"
                      autoComplete="off"
                      className="inputLabelText ml-2 mt-2 px-4 py-3 focus:outline-none"
                      // onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="flex w-full mt-6">
                  <div className="w-5/12">
                    <span className="text-gray-400">Zip</span>
                    <input
                      type="text"
                      value={formData.address.zip}
                      name="zip"
                      placeholder="ZIP"
                      autoComplete="off"
                      className="inputLabelText px-4 py-3 mt-2 rounded-xl focus:outline-none"
                      onChange={handleAddressChange}
                    />
                  </div>
                </div>
                <div className="flex w-full justify-end">
                  <div className="mr-10 ml-auto">
                    <button
                      type="submit"
                      onClick={() => setEdit(false)}
                      className="rounded-3xl border focus:outline-none w-28 h-9 mr-3 cursor-pointer "
                      // style={{ border: '1px solid #16406D' }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="rounded-3xl focus:outline-none w-28 h-9 text-white cursor-pointer"
                      style={{ background: '#16406D' }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
        {/* <div className="z-50" style={{ height: '22vh', background: '#f9f9f9', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-textBlue1 font-bold text-xl">Organization Settings</span>
          </div>
        </div> */}

        <div className="tbl h-full" style={{ minWidth: '700px', display: 'none' }}>
          <div className="bg-tableBg w-tableWidth m-auto pb-5" style={{ minHeight: '85%' }}>
            <div className="flex">
              <div className="w-full p-4">
                <div>
                  <p className="mt-3 font-bold text-lg text-textBlue1">Organization Info</p>
                  {formData && (
                    <form className="mt-2 flex flex-wrap" onSubmit={handleSubmit} autoComplete="off">
                      <div className=" w-1/4 items-center  my-3.5">
                        <label htmlFor="website" className="mb-1 block text-parameter text-sm">
                          Customer API Key
                        </label>
                        <input
                          type="text"
                          value={orgData?.data?.organization?.ClientApiKey?.clientId}
                          name="api-key"
                          disabled
                          className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
                        />
                      </div>
                      <div className=" w-1/4 items-center  my-3.5">
                        <label htmlFor="website" className="mb-1 block text-parameter text-sm">
                          WEBSITE
                        </label>
                        <input
                          type="text"
                          value={formData.website}
                          name="website"
                          className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className=" w-1/4 items-center  my-3.5">
                        <label htmlFor="email" className="mb-1 block text-parameter text-sm">
                          EMAIL
                        </label>
                        <input
                          type="email"
                          value={formData.email}
                          name="email"
                          className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className=" w-1/4 items-center  my-3.5">
                        <label htmlFor="contact" className="mb-1 block text-parameter  text-sm">
                          PHONE NUMBER
                        </label>
                        <input
                          type="tel"
                          value={formData.contactNo}
                          name="contactNo"
                          className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className=" w-full items-center">
                        <p className="mt-3 font-bold text-lg text-textBlue1">Address</p>
                      </div>

                      <div className=" w-1/4 items-center my-3.5 relative">
                        <label htmlFor="locality" className="mb-1 block text-parameter  text-sm uppercase">
                          Locality
                        </label>

                        <input
                          type="text"
                          value={formData.address.location}
                          name="location"
                          className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
                          onChange={handleAddressChange}
                        />
                      </div>

                      <div className=" w-1/4 items-center my-3.5 relative">
                        <label htmlFor="city" className="mb-1 block text-parameter  text-sm uppercase">
                          City
                        </label>

                        <input
                          type="text"
                          value={formData.address.city}
                          name="city"
                          className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
                          onChange={handleAddressChange}
                        />
                      </div>

                      <div className=" w-1/4 items-center my-3.5 relative">
                        <label htmlFor="state" className="mb-1 block text-parameter  text-sm uppercase">
                          State
                        </label>

                        <input
                          type="text"
                          value={formData.address.state}
                          name="state"
                          className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
                          onChange={handleAddressChange}
                        />
                      </div>
                      <div className=" w-1/4 items-center my-3.5 relative">
                        <label htmlFor="country" className="mb-1 block text-parameter  text-sm uppercase">
                          Country
                        </label>

                        <input
                          type="text"
                          value={formData.address.country}
                          name="country"
                          className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
                          onChange={handleAddressChange}
                        />
                      </div>
                      <div className=" w-1/4 items-center my-3.5 relative">
                        <label htmlFor="zip" className="mb-1 block text-parameter  text-sm uppercase">
                          Zip
                        </label>

                        <input
                          type="text"
                          value={formData.address.zip}
                          name="zip"
                          className="rounded-lg w-11/12 bg-white px-4 py-3 focus:outline-none  text-parameter border  h-10"
                          onChange={handleAddressChange}
                        />
                      </div>

                      <div className="flex w-full items-center justify-end mt-3 relative">
                        {isLoading ? (
                          <img src="assets/img/loader.svg" className="w-10 mr-6 ml-auto" alt="" />
                        ) : (
                          <input
                            type="submit"
                            value="Save Changes"
                            className="rounded-lg focus:outline-none w-1/5 mr-8 h-10 text-textBlue1 cursor-pointer "
                            style={{ background: '#16406D33', border: '1px solid #16406D' }}
                          />
                        )}
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default index;
